import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  right: ${(prop: any) => (prop.in === 'in' ? ' -63px' : 0)};

  z-index: 9192;
  background: linear-gradient(180deg, #f53d2d, #f63);
  color: var(--white);
  display: flex;
  align-items: center;
  transition: all 0.2s ease-out;
  @media (min-width: 567px) {
    top: 140px;
  }
  @media (max-width: 567px) {
    bottom: 160px;
  }
  @media (max-width: 768px) {
    right: ${(prop: any) => (prop.in === 'in' ? ' -40px' : 0)};
  }

  ul {
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
    border-left: 1px solid var(--white);
    transition: all 0.2s ease-out;

    li {
      display: block;
      text-align: center;
      padding: 0.5rem;
      border-bottom: 1px solid var(--white);
      &:last-child {
        border-color: transparent;
      }

      svg {
        width: 30px;
        fill: var(--white);
        @media (max-width: 768px) {
          width: 25px;
        }
        path {
          fill: var(--white);
        }
      }
    }
    span {
      display: block;
      font-size: 0.75rem;
      color: var(--white);
      line-height: 1.5;

      @media (max-width: 768px) {
        display: none;
      }
    }
  }
`;

export const ToggleButton = styled.a`
  display: block;
  height: 30px;
  line-height: 30px;
  color: var(--white);
  text-align: center;
  cursor: pointer;
  transform: rotate(-90deg);
  text-transform: capitalize;
  user-select: none;
  left: -138px;
  width: 243px;
  position: absolute;
  background: linear-gradient(180deg, #f53d2d, #f63);
  border-radius: 4px 4px 0 0;
  @media (max-width: 768px) {
    left: -95px;
    width: 160px;
  }
`;
